import { CreateAssetPayload } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useMutation } from '@tanstack/react-query';
import { AxiosProgressEvent } from 'axios';

type CreateAssetOptions = {
  onUploadProgress?: (progressEvent: AxiosProgressEvent, fileId: string) => void;
};

export const useCreateAsset = () => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: (data: { payload: CreateAssetPayload; options?: CreateAssetOptions }) => {
      return api.assets.createAsset(tenantId, data.payload, {
        onUploadProgress: data.options?.onUploadProgress
          ? event => data.options?.onUploadProgress?.(event, data.payload.path)
          : undefined,
      });
    },
  });

  return {
    createAsset: mutateAsync,
    isLoading: isPending,
    error,
  };
};
